import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React from 'react';

import {
  CriteriaTextWrapper,
  MatchStyledText,
} from './SmartChoiceBreakDown.styles';

interface MatchTextProps {
  text: string | undefined;
  StartIcon?: React.ReactNode;
  EndIcon?: React.ReactNode;
  noIcon?: boolean;
}
export const MatchText = ({
  text,
  StartIcon,
  EndIcon,
  noIcon,
}: MatchTextProps) => (
  <CriteriaTextWrapper data-testid={`match-text-${text}`}>
    {!noIcon && (
      <div>
        <IconSymbol color="#007000" data-testid="tick-icon" icon="done" />
      </div>
    )}
    {StartIcon && <React.Fragment>{StartIcon}</React.Fragment>}

    {text && (
      <CriteriaTextWrapper>
        <MatchStyledText
          css={noIcon ? { paddingLeft: '36px' } : {}}
          data-testid="preference-text"
        >
          {text}
        </MatchStyledText>

        {EndIcon && <React.Fragment>{EndIcon}</React.Fragment>}
      </CriteriaTextWrapper>
    )}
  </CriteriaTextWrapper>
);
